function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: 1.125rem 1.125rem 0 0;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: 0.5rem;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0.2187rem;\n  padding-left: 1rem;\n  color: ", ";\n  font-size: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  resize: ", ";\n  display: block;\n  color: ", ";\n  border: 0.0625rem solid ", ";\n  border-radius: 0.1875rem;\n  width: calc(100% - 2rem - 2px);\n  position: relative;\n  padding: 1.25rem 1rem;\n  font-size: ", ";\n  font-weight: ", ";\n  background-color: ", " !important;\n  border-bottom: 0.0625rem solid ", ";\n\n  &:focus {\n    outline: none;\n    padding: 1.75rem 1rem 0.75rem 1rem;\n    border-bottom: 0.125rem solid ", ";\n    margin-bottom: -0.0625rem;\n\n    & + ", " {\n      padding-top: 0.375rem;\n      display: block;\n      font-size: ", ";\n      color: ", ";\n    }\n  }\n\n  &:disabled {\n    border: 0.0625rem solid transparent;\n  }\n\n  & + ", " {\n    line-height: normal;\n    padding-top: 0.8125rem;\n    color: ", ";\n  }\n\n  ", ";\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    box-shadow: 0 0 0 1.875rem ", " inset !important;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 1.75rem 1rem 0.75rem 1rem;\n\n  & + ", " {\n    display: block;\n    padding-top: 0.375rem;\n    font-size: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  padding-top: 0.8125rem;\n  top: 0.0625rem;\n  left: 0.0625rem;\n  transition: font-size 0.3s, top 0.3s;\n  padding-left: 1rem;\n  font-size: ", ";\n  pointer-events: none;\n  background-color: white;\n  width: calc(100% - 5rem);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n  width: 100%;\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  font-family: ", ";\n  font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled, { css } from "../../theme";

var getLabelColor = function getLabelColor(props, defaultColor) {
  if (props.disabled) {
    return defaultColor;
  }

  if (props.hasError) {
    return props.theme.variables.colors.red;
  }

  return defaultColor;
};

export var getBorderColor = function getBorderColor(props, defaultColor) {
  if (props.disabled) {
    return defaultColor;
  }

  if (props.hasError) {
    return props.theme.variables.colors.red;
  }

  if (props.isModified) {
    return props.theme.variables.colors.blue;
  }

  return defaultColor;
};
export var TextareaWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.variables.typography.primaryFont;
}, function (props) {
  return props.theme.variables.fonts.weight.light;
});
export var TextareaContent = styled.div(_templateObject2(), function (props) {
  return props.theme.variables.colors.white;
});
export var TextareaLabel = styled.label(_templateObject3(), function (props) {
  return props.theme.variables.fonts.size.base;
});
var filledInputTextStyle = css(_templateObject4(), TextareaLabel, function (props) {
  return props.theme.variables.fonts.size.smaller1;
}, function (props) {
  return getLabelColor(props, props.theme.variables.colors.darkGrey);
});
export var TextareaText = styled.textarea(_templateObject5(), function (p) {
  return p.resizeable ? 'vertical' : 'none';
}, function (props) {
  return props.theme.variables.colors.black;
}, function (props) {
  return props.theme.variables.colors.platinum;
}, function (props) {
  return props.theme.variables.fonts.size.base;
}, function (props) {
  return props.theme.variables.fonts.weight.light;
}, function (props) {
  return props.theme.variables.colors.white;
}, function (props) {
  return getBorderColor(props, props.theme.variables.colors.midGrey);
}, function (props) {
  return getBorderColor(props, props.theme.variables.colors.blue);
}, TextareaLabel, function (props) {
  return props.theme.variables.fonts.size.smaller1;
}, function (props) {
  return getLabelColor(props, props.theme.variables.colors.blue);
}, TextareaLabel, function (props) {
  return getLabelColor(props, props.theme.variables.colors.darkGrey);
}, function (props) {
  return props.isFilled && filledInputTextStyle;
}, function (props) {
  return props.theme.variables.colors.white;
});
export var ErrorMessage = styled.div(_templateObject6(), function (props) {
  return props.theme.variables.colors.red;
}, function (props) {
  return props.theme.variables.fonts.size.smaller1;
});
export var ClearIconWrapper = styled.div(_templateObject7());
export var CharsCouterContainer = styled.div(_templateObject8(), function (props) {
  return props.theme.variables.typography.secondaryFont;
}, function (props) {
  return props.theme.variables.fonts.weight.bold;
}, function (props) {
  return props.theme.variables.fonts.size.smaller1;
});
export var CharsNumber = styled.div(_templateObject9(), function (props) {
  return props.theme.variables.customColors.lightNavy;
});
export var MaxChars = styled.div(_templateObject10(), function (props) {
  return props.theme.variables.customColors.lightBlue;
});